import pickBy from 'lodash/pickBy';

export const mapFormToIdentificationCodeType = values => ({
  ...pickBy(values || {}, v => v !== null && v !== undefined && v !== ''),
  owners: (values?.owners || [])
    .map(o => pickBy(o, v => v !== null && v !== undefined && v !== ''))
    .filter(o => o.organisationId),
});
